module.exports = __webpack_public_path__ + "static/media/green.1b692019.svg";